import * as React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PROFILE_PAGE, VERIFY_PAGE } from 'constants/route.const';
import { UserService } from 'service/UserService';
import { StorageService } from 'service/Storage';

export const useAutoLogin = ({ setShowOtpForm, setAccountBlocked }) => {
  const navigate = useNavigate();
  let refreshToken = useSearchParams()[0].get('rt');
  let paramMobile = useSearchParams()[0].get('mobile');
  React.useEffect(() => {
    const fn = async () => {
      try {
        const res = await UserService.getTokenForAutoLogin(refreshToken);
        StorageService.setAccessToken(res.access_token);
        StorageService.setRefreshToken(res.refresh_token);
        const res2 = await UserService.getWID();
        StorageService.setWId(res2.wid);
        StorageService.setMobile(paramMobile);
        navigate(PROFILE_PAGE, { replace: true });
      } catch (e) {
        if (e.data?.error_code === 1003 || e.data?.error_code === 1004) {
          setShowOtpForm(false);
          setAccountBlocked(true);
          return;
        }
        if (paramMobile) {
          navigate(VERIFY_PAGE + `?mobile=${paramMobile}`, {
            replace: true,
            state: { mobile: paramMobile },
          });
          return;
        }
        navigate(VERIFY_PAGE, { replace: true });
      }
    };
    if (refreshToken) {
      StorageService.setAccessToken();
      StorageService.setRefreshToken();
      StorageService.setWId();
      StorageService.setUserId();
      StorageService.setMobile(paramMobile);
      fn();
    }
  }, []);
};
